import React from "react";

export function safeHttpUrl(value) {
  if (typeof value !== "string" || /\s/.test(value)
    || [...value].some((character) => character.charCodeAt(0) < 32 || character.charCodeAt(0) === 127)) return null;
  try {
    const url = new URL(value);
    return ["https:", "http:"].includes(url.protocol) && !url.username && !url.password
      ? url.href : null;
  } catch {
    return null;
  }
}

// Return React nodes, never HTML. All unmatched text stays escaped by React.
export function processLinks(text) {
  if (typeof text !== "string") return "";
  const nodes = [];
  const urls = /\bhttps?:\/\/[^\s<>"'`]+/gi;
  let offset = 0;
  for (const match of text.matchAll(urls)) {
    const candidate = match[0].replace(/[),.!?;:]+$/, "");
    const href = safeHttpUrl(candidate);
    if (!href) continue;
    nodes.push(text.slice(offset, match.index));
    const hostname = new URL(href).hostname;
    const label = hostname === "play.google.com" ? "Download on Android"
      : hostname === "apps.apple.com" ? "Download on iOS"
        : hostname === "mydtdc.in" || hostname.endsWith(".mydtdc.in") ? "Visit Website" : "Click Here";
    nodes.push(<a key={match.index} href={href} target="_blank" rel="noopener noreferrer">{label}</a>);
    offset = match.index + candidate.length;
  }
  nodes.push(text.slice(offset));
  return nodes;
}

export function useMessageProcessing() {
  return { processLinks };
}
